/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMMaterialConsumeDTO
 */
export interface IMMaterialConsumeDTO {
    /**
     * 
     * @type {string}
     * @memberof IMMaterialConsumeDTO
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof IMMaterialConsumeDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof IMMaterialConsumeDTO
     */
    materialCode?: string;
    /**
     * 
     * @type {number}
     * @memberof IMMaterialConsumeDTO
     */
    qty?: number;
    /**
     * 
     * @type {string}
     * @memberof IMMaterialConsumeDTO
     */
    warehouseCode?: string;
}

/**
 * Check if a given object implements the IMMaterialConsumeDTO interface.
 */
export function instanceOfIMMaterialConsumeDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IMMaterialConsumeDTOFromJSON(json: any): IMMaterialConsumeDTO {
    return IMMaterialConsumeDTOFromJSONTyped(json, false);
}

export function IMMaterialConsumeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMMaterialConsumeDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'materialCode': !exists(json, 'materialCode') ? undefined : json['materialCode'],
        'qty': !exists(json, 'qty') ? undefined : json['qty'],
        'warehouseCode': !exists(json, 'warehouseCode') ? undefined : json['warehouseCode'],
    };
}

export function IMMaterialConsumeDTOToJSON(value?: IMMaterialConsumeDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'comment': value.comment,
        'id': value.id,
        'materialCode': value.materialCode,
        'qty': value.qty,
        'warehouseCode': value.warehouseCode,
    };
}

